// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/sass/iconfont.scss
// module id = ./src/sass/iconfont.scss
// module chunks = 7